import { useCallback } from 'react'
import useClickOutside from './useClickOutside'
import useToggle from 'common/hooks/useToggle'

const useToggleMenu = ref => {
  const [showing, toggle] = useToggle()
  const show = useCallback(() => !showing && toggle(true), [showing])
  const hide = useCallback(() => toggle(false), [])
  useClickOutside(ref, showing && hide)
  return [showing, show, hide, toggle]
}

export default useToggleMenu
